export const UsersActionTypes = {
    API_RESPONSE_SUCCESS: '@@users/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@users/API_RESPONSE_ERROR',

    GET_ALL_USERS: '@@users/GET_ALL_USERS',

    RESET_ALL_ERRORS: '@@users/RESET_ALL_ERRORS',
};
